import { Component, OnInit, ViewChild } from '@angular/core';
import { UserInfo } from '../shared/user-info.model';
import { Observable } from 'rxjs';
import { UserFormComponent } from '../user-form/user-form.component';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../shared/services/navigation.service';
import { UserService } from '../shared/user.service';
import { LoaderService } from '../../shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { DisplayMode } from '../../shared/display-mode';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalLocationContainerLight } from '../../local-loads/shared/local-location-container-light.model';
import { LocalLocationService } from '../../local-loads/shared/local-location.service';

@Component({
  selector: 'app-plant-manager-form',
  templateUrl: './plant-manager-form.component.html',
  styleUrls: ['./plant-manager-form.component.scss']
})
export class PlantManagerFormComponent implements OnInit {

  user: UserInfo = new UserInfo();

  plants: LocalLocationContainerLight[] = [];

  onCreate: (u: UserInfo) => Observable<UserInfo>;
  onUpdate: (u: UserInfo) => Observable<UserInfo>;
  onDelete: (u: UserInfo) => Observable<boolean>;
  onToggleBlocking: (u: UserInfo) => Observable<boolean>;
  onUnblockIp: (u: UserInfo) => Observable<boolean>;

  mode = DisplayMode.Creation;

  DisplayMode = DisplayMode;

  @ViewChild('userForm')
  userFormComponent: UserFormComponent;

  constructor(
    private route: ActivatedRoute,
    private navigation: NavigationService,
    private userService: UserService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService,
    private locationService: LocalLocationService,
  ) {
    this.onCreate         = u => this.userService.createPlantManager(u);
    this.onUpdate         = u => this.userService.updatePlantManager(u);
    this.onDelete         = u => this.userService.deletePlantManager(u.id);
    this.onToggleBlocking = u => this.userService.toggleBlockingPlantManager(u);
    this.onUnblockIp      = u => this.userService.unblockIpPlantManager(u);

    this.locationService.getAvailablePlants().subscribe(plants => {
      this.plants = plants;
    })
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const chepManagerId = params.id;

      if (!!chepManagerId) {
        this.loader.startLoad(false);

        this.userService.getById(chepManagerId)
          .pipe(finalize(() => this.loader.stopLoad()))
          .subscribe(chepManager => {
            this.user = chepManager;
            this.switchToUpdateMode();
          }, e => this.errorHandler.handleHttpError(e, 'user-dashboard.users.plant-managers.errors.get-one'));
      }
    });
  }

  getForm() {
    return this.userFormComponent.form;
  }

  switchToUpdateMode(): void {
    this.mode = DisplayMode.Edition;
  }

  goToPlantManagerList() {
    this.navigation.plantManagers()
      .list()
      .go();
  }

  changePassword(password: string) {
    this.loader.startLoad();
    this.userService.updatePassword(this.user, password)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(() => {
        this.toastr.success(this.translate.instant('user-dashboard.users.successes.update-password'));
      }, e => this.errorHandler.handleHttpError(e, 'user-dashboard.users.errors.update-password'));
  }
}
